import { useTranslation } from 'react-i18next';

import { I18nText } from '../../../types';

export type TranslateFunction = (
  i18nText: I18nText,
  options?: Record<string, unknown>
) => string;

interface UseTranslateReturnType {
  t: TranslateFunction;
}

function useTranslate(): UseTranslateReturnType {
  const { t } = useTranslation();

  return { t };
}

export default useTranslate;
